import React from 'react';
import { PhoneInput } from '@law-connect/react-components-form/phone-input';
import { CheckboxInput } from '@law-connect/react-components-general/checkbox-label';
import style from './styles.module.less';
import { useTranslation } from 'react-i18next';

interface AuthModalBodyContentProps {
  showPhoneNumber: boolean;
  showVerificationStep: boolean;
  verificationCode: string;
  setVerificationCode: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  isLoading: boolean;

  showTerms: boolean;
  termsAccepted: boolean;
  setTermsAccepted: (value: boolean) => void;

  marketingEmails: boolean;
  setMarketingEmails: (value: boolean) => void;
}

export const AuthModalBodyContent: React.FC<AuthModalBodyContentProps> = (
  props
) => {
  const {
    showPhoneNumber,
    showVerificationStep,
    phoneNumber,
    verificationCode,
    isLoading,
    setPhoneNumber,
    setVerificationCode,
    showTerms,
    termsAccepted,
    setTermsAccepted,
    marketingEmails,
    setMarketingEmails,
  } = props;

  const { t } = useTranslation();
  const BODY_CONTENT: React.ReactNode[] = [];

  if (showPhoneNumber) {
    BODY_CONTENT.push(
      showVerificationStep ? (
        <div
          className={style.phoneInputContainer}
          key='verification-code-input'
        >
          <div className={style.phoneInputLabel}>
            {t('auth.confirmation-code')}
          </div>
          <input
            type='text'
            className={style.phoneInput}
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder={t('auth.enter-code')}
            maxLength={6}
            disabled={isLoading}
          />
        </div>
      ) : (
        <div className={style.phoneInputContainer} key='phone-input'>
          <div className={style.phoneInputLabel}>
            {t('account.edit-profile.phone')}
          </div>
          <PhoneInput
            value={phoneNumber}
            onChange={setPhoneNumber}
            className={style.phoneInput}
            disabled={isLoading}
            props={{
              style: {
                backgroundColor: 'var(--white)',
              },
            }}
          />
        </div>
      )
    );
  }

  if (showTerms) {
    BODY_CONTENT.push(
      <div className={style.termsWrapper} key='terms-wrapper'>
        <div className={style.termsContainer}>
          <CheckboxInput
            label={
              <div
                className={style.termsCheckboxLabel}
                dangerouslySetInnerHTML={{ __html: t('auth.modal.footer') }}
              />
            }
            checked={termsAccepted}
            onChange={setTermsAccepted}
            className={style.termsCheckboxContainer}
          />
        </div>
        <div className={style.termsContainer}>
          <CheckboxInput
            label={
              <div className={style.termsCheckboxLabel}>
                {t('auth.marketing-consent')}
              </div>
            }
            checked={marketingEmails}
            onChange={setMarketingEmails}
            className={style.termsCheckboxContainer}
          />
        </div>
      </div>
    );
  }

  return BODY_CONTENT;
};

interface FooterProps {
  showMobile: boolean;
  showVerificationStep: boolean;
  resendCode: () => void;
}

export const AuthBodyFooter: React.FC<FooterProps> = (props) => {
  const { showVerificationStep, showMobile, resendCode } = props;
  const { t } = useTranslation();
  return showVerificationStep && showMobile ? (
    <div className={style.resendCode}>
      {t('auth.didnt-receive-code')}&nbsp;
      <button onClick={resendCode} className={style.resendButton}>
        {t('auth.send-again')}
      </button>
      .
    </div>
  ) : undefined;
};
